export default "/images/8d6768dba345bd49877789e676460f6a.png";